export default {
  data() {
    return {
      props: {
        'tag': '',
        'smartTag': '',
        'flag': '',
        'content': 'Texto exemplo',
        'checkBoxTextBackgroundHover': false,
        'textBackgroundColorHover': '#ffffff',
        'zIndex': 'auto','maxWidth': '500px',
        'rotation': '0deg',
        'width': '500px',
        'fontSizeMobile': '12px',
        'alignMobile': 'center',
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
        'isGradientText': false,
        'textGradientColor': '#ffffff',
        'hideDesktopOrder': 0,
        'hideMobileOrder': 0,
        'animation': {
          'in': {
            'action': 'time',   //time/scroll/click/hover
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'speed': 'slow',
            'infinite': false,
          },
          'out': {
            'action': 'time',   //time/scroll/click
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'delay': '1',
            'speed': '1',
            'infinite': false,
          },
        },
      },
      internal_config: {
        content: 'Texto exemplo',
        'checkBoxTextBackgroundHover': false,
        'textBackgroundColorHover': '#ffffff',
        'zIndex': 'auto',
        'rotation': '0deg',
        fontSizeMobile: '12px',
        alignMobile: 'left',
        width: '300px',
        left: '0px',
        top: '0px',
        showDesktop: true,
        showMobile: true,
        hideDesktopOrder: 0,
        hideMobileOrder: 0,
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
        'isGradientText': false,
        'textGradientColor': '#ffffff',

        /**
         * pinConfig : configuração para fixação de elementos - Pin.vue
         */
        'pinConfig': {
          'pin' : false,
          'pTop' : '0',
          'pBottom' : '0',
          'pLeft' : '0',
          'pRight' : '0',
          'position': '',
        },
      },
      editing: false,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/apps/Text/Model.js